/**
 * Класс для управления дополнительным блоком номинаций
 */
class NominationBlock {
  constructor(element) {
    /**
     * Основной элемент блока номинации
     * @type {HTMLElement}
     */
    this.block = element;
    this.addButton = this.block.querySelector('.js-add-nomination');
    this.additionalBlock = this.block.querySelector('.js-additional-nomination');

    this.addButton.addEventListener('click', () => this.toggle());
  }

  /**
   * Переключает видимость элементов блока номинации
   * @returns {void}
   */
  toggle() {
    this.additionalBlock?.classList.remove('d-none');
    this.addButton?.classList.add('d-none');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.js-nomination-block').forEach((el) => new NominationBlock(el));
});
